import React from 'react';

const Footer = () => (
  <footer id="footer" className="footer has-background-dark">
    <div className="content has-text-centered">
      <div className="mb-4">
        <p className="has-text-white">
          <strong className="has-text-white is-size-5">AZCOREMSH.NET</strong>
        </p>
        <p className="has-text-grey-light is-size-6">
          Building Arizona's decentralized mesh network
        </p>
      </div>
      <div className="buttons is-centered">
        <a href="https://github.com/meshcore-dev/MeshCore" target="_blank" rel="noopener noreferrer" className="button is-small is-dark">
          <span className="icon">
            <i className="fab fa-github"></i>
          </span>
        </a>
        <a href="https://discord.gg/RPj3b7ZUz9" target="_blank" rel="noopener noreferrer" className="button is-small is-dark">
          <span className="icon">
            <i className="fab fa-discord"></i>
          </span>
        </a>
      </div>
      <p className="has-text-grey-light is-size-7 mt-4">
        &copy; {new Date().getFullYear()} AZCOREMSH.NET. Open source and community-driven.
      </p>
    </div>
  </footer>
);

export default Footer;
